function cov_u47itb605() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/RefreshFilled.tsx";
  var hash = "c8ad7eea98b9fc866e1995943c01a267a01036ac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/RefreshFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c8ad7eea98b9fc866e1995943c01a267a01036ac"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_u47itb605 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_u47itb605();
var Icon = (cov_u47itb605().s[0]++, {
  name: 'refresh-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.6116 6.83381L11.109 6.41925C7.80629 6.82895 5.25 9.64554 5.25 13.0592C5.25 16.7546 8.24574 19.7504 11.9412 19.7504C15.6366 19.7504 18.6324 16.7546 18.6324 13.0592C18.6324 12.3688 19.192 11.8092 19.8824 11.8092C20.5727 11.8092 21.1324 12.3688 21.1324 13.0592C21.1324 18.1353 17.0173 22.2504 11.9412 22.2504C6.86503 22.2504 2.75 18.1353 2.75 13.0592C2.75 8.2523 6.44006 4.30727 11.142 3.90228L10.6116 3.46025C10.0812 3.01829 10.0096 2.23008 10.4515 1.69974C10.8935 1.16939 11.6817 1.09774 12.212 1.53969L15.2046 4.03351C15.9 4.61301 15.9 5.68106 15.2046 6.26056L12.212 8.75436C11.6817 9.19632 10.8935 9.12466 10.4515 8.59432C10.0096 8.06397 10.0812 7.27576 10.6116 6.83381ZM12 17.5C14.2091 17.5 16 15.7091 16 13.5C16 11.2908 14.2091 9.49997 12 9.49997C9.79086 9.49997 8 11.2908 8 13.5C8 15.7091 9.79086 17.5 12 17.5Z\" fill=\"currentColor\"/>"
});
export default Icon;